import React from 'react';
export const TriangleSvg: React.FC = () => {
  return (
    <svg
      width="19"
      height="10"
      viewBox="0 0 19 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1692 9.39724C9.78885 9.73984 9.21115 9.73984 8.83076 9.39724L0.609968 1.99305C-0.070889 1.37982 0.362905 0.25 1.27921 0.25L17.7208 0.249998C18.6371 0.249998 19.0709 1.37982 18.39 1.99305L10.1692 9.39724Z"
        fill="white"
      />
      <path
        d="M9.16538 9.02572L0.944587 1.62152C0.604161 1.31491 0.821054 0.75 1.27921 0.75L17.7208 0.749998C18.1789 0.749998 18.3958 1.31491 18.0554 1.62152L9.83462 9.02572C9.64443 9.19702 9.35558 9.19702 9.16538 9.02572Z"
        stroke="#A8C6A1"
      />
    </svg>
  );
};
